// import { WalletSearch } from 'iconsax-react'
import React from 'react'
import { useParams } from 'react-router-dom'
import Bills from '../bills/Bills'
import Calculator from '../calculator/Calculator'
// import CryptoCalc from '../calculator/CryptoCalc'
// import CryptoTrade from '../crypto/CryptoTrade'
import Main from '../main/Main'
import Navbar from '../navbar/Navbar'
import PersonalInfo from '../personlInfo/PersonalInfo'
import Referrals from '../referrals/Referrals'
import Settings from '../settings/Settings'
import Trade from '../trade/Trade'
import TradeDetails from '../trade/TradeDetails'
import Transaction from '../transactions/Transaction'
import Wallets from '../wallet/Wallets'
import style from './right.module.css'
import ExchangePage from '../exchange/Exchange'
import VirtualCardsPage from '../VirtualCards/virtualCards'
import PrediqoPage from '../prediqo/prediqo'
import BetDetailPage from '../prediqo/BetDetailPage'
import DepositPage from '../deposit/deposit'
import DepositWithFiatPage from '../deposit/depositWithFiat'
import DepositWithCryptoPage from '../deposit/depositWithCrypto'
import CryptoWalletPage from '../wallet/CryptoWallet'
import FiatWalletPage from '../wallet/FiatWallet'
import WithdrawWithFiatPage from '../withdraw/withdrawWithFiat'
import WithdrawPage from '../withdraw/withdraw'
import OrderBookPage from '../wallet/OrderBook'

const Right = ({ links, newRoute, setNewRoute, verifiedKYC, dynTitle, setDynTitle, setVerifiedKYC, openSidebar, setOpenSidebar, calcRoute, setCalcRoute }) => {
  
  const param = useParams();
  const paramName = param.cardname;

  return (
    <div className={style.right}>
      <div className={style.top}>
        <Navbar
          links={links}
          newRoute={newRoute}
          setNewRoute={setNewRoute}
          dynTitle={dynTitle}
          setDynTitle={setDynTitle}
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
        />
      </div>
      <div className={style.bottom}>
        {window.location.pathname === "/dashboard" && (
          <Main
            newRoute={newRoute}
            verifiedKYC={verifiedKYC}
            setNewRoute={setNewRoute}
          />
        )}
        {window.location.pathname === "/trade" && (
          <Trade verifiedKYC={verifiedKYC} />
        )}
        {window.location.pathname === `/trade/${paramName}` && (
          <TradeDetails verifiedKYC={verifiedKYC} />
        )}

        {/* ======================= EVERYTHING UNDER CRYPTO SECTION ========================== */}
        {/* {window.location.pathname === "/crypto" && (
          <CryptoTrade verifiedKYC={verifiedKYC} />
        )} */}

        {/* ========== EVERYTHING UNDER Deposit SECTION =============== */}
        {window.location.pathname === "/deposit" && (
          <DepositPage verifiedKYC={verifiedKYC} />
        )}

          {/* ========== EVERYTHING UNDER Deposit SECTION =============== */}
        {window.location.pathname === "/deposit-with-fiat" && (
          <DepositWithFiatPage verifiedKYC={verifiedKYC} />
        )}

          {/* ========== EVERYTHING UNDER Deposit SECTION =============== */}
        {window.location.pathname === "/deposit-with-crypto" && (
          <DepositWithCryptoPage verifiedKYC={verifiedKYC} />
        )}

          {/* ========== EVERYTHING UNDER EXCHANGE SECTION =============== */}
          {window.location.pathname === "/swap" && (
          <ExchangePage verifiedKYC={verifiedKYC} />
        )}

        {/* =========== EVERYTHING UNDER TRANSFER SECTION =================== */}
        {window.location.pathname === "/withdraw" && (
          <WithdrawPage verifiedKYC={verifiedKYC} />
        )}

          {/* ========== EVERYTHING UNDER Deposit SECTION =============== */}
        {window.location.pathname === "/withdraw-with-fiat" && (
          <WithdrawWithFiatPage verifiedKYC={verifiedKYC} />
        )}

       {/* ========== EVERYTHING UNDER VIRTUAL CARDS SECTION =============== */}
            {window.location.pathname === "/virtual-cards" && (
          <VirtualCardsPage verifiedKYC={verifiedKYC} />
        )}

           {/* ========== EVERYTHING UNDER PREDIQO SECTION =============== */}
          {window.location.pathname === "/prediqo" && (
          <PrediqoPage verifiedKYC={verifiedKYC} />
        )}

        {/* ======================= EVERYTHING UNDER BET DETAIL SECTION ========================== */}
        {window.location.pathname === `/bet-detail/${param.betId}` && (
          <BetDetailPage verifiedKYC={verifiedKYC} />
        )}


        {/* ======================= EVERYTHING UNDER BILL PAYMENT SECTION ========================== */}
        {window.location.pathname === "/bills" && (
          <Bills verifiedKYC={verifiedKYC} />
        )}
        {window.location.pathname === "/bills/cable" && (
          <Bills verifiedKYC={verifiedKYC} />
        )}
        {window.location.pathname === "/bills/airtime" && (
          <Bills verifiedKYC={verifiedKYC} />
        )}
        {window.location.pathname === "/bills/data" && (
          <Bills verifiedKYC={verifiedKYC} />
        )}
        {window.location.pathname === "/bills/electricity" && (
          <Bills verifiedKYC={verifiedKYC} />
        )}

        {window.location.pathname === "/wallets" && (
          <Wallets verifiedKYC={verifiedKYC} />
        )}

         {window.location.pathname === "/crypto-wallet" && (
          <CryptoWalletPage verifiedKYC={verifiedKYC} />
        )}

         {window.location.pathname === "/fiat-wallet" && (
          <FiatWalletPage verifiedKYC={verifiedKYC} />
        )}


         {window.location.pathname === "/order-book" && (
          <OrderBookPage verifiedKYC={verifiedKYC} />
        )}

        {window.location.pathname === "/transactions" && (
          <Transaction verifiedKYC={verifiedKYC} />
        )}

        {window.location.pathname === "/calculator" && (
          <Calculator
            calcRoute={calcRoute}
            setCalcRoute={setCalcRoute}
            verifiedKYC={verifiedKYC}
          />
        )}
        {window.location.pathname === "/referrals" && (
          <Referrals verifiedKYC={verifiedKYC} />
        )}

        {/* ======================= EVERYTHING UNDER DASHBOARD SECTION ========================== */}
        {window.location.pathname === "/dashboard/personal-info" && (
          <PersonalInfo
            setVerifiedKYC={setVerifiedKYC}
            verifiedKYC={verifiedKYC}
          />
        )}
        {window.location.pathname === "/dashboard/account-details" && (
          <PersonalInfo
            setVerifiedKYC={setVerifiedKYC}
            verifiedKYC={verifiedKYC}
          />
        )}
        {window.location.pathname === "/dashboard/transaction-pin" && (
          <PersonalInfo
            setVerifiedKYC={setVerifiedKYC}
            verifiedKYC={verifiedKYC}
          />
        )}

        {window.location.pathname === "/settings" && (
          <Settings
            newRoute={newRoute}
            setNewRoute={setNewRoute}
            verifiedKYC={verifiedKYC}
            dynTitle={dynTitle}
            setDynTitle={setDynTitle}
          />
        )}
      </div>
    </div>
  );
}

export default Right 